export function urlToObject(): Object {
  const query = (window.location.search || "?").substr(1),
    map = {};
  const urlRE = /([^&=]+)=?([^&]*)(?:&+|$)/g;
  query.replace(urlRE, (match, key, value) => {
    map[key] = this.stripStringTags(decodeURIComponent(value));
    return "";
  });
  return map;
}

export function stripStringTags(value: string): string {
  const tagsRE = /<\/?[^>]+>/g;
  return value.replace(tagsRE, "");
}

export function objectToArray(value: Object): any {
  const resultArray = Object.keys(value).map(idx => {
    return value[idx];
  });
  return resultArray;
}

export function includes(arr: any[], str: string) {
  return arr.indexOf(str) > -1;
}

export function filterOut(arr1: any[], arr2: any[]) {
  return arr1.filter(val => {
    return arr2.indexOf(val) === -1;
  });
}

export function concatUnique(arr1: any[], arr2: any[]) {
  const newArr = [].concat(arr1 || []); // shallow copy
  arr2.forEach(val => {
    if (val && newArr.indexOf(val) === -1) {
      newArr.push(val);
    }
  });
  return newArr;
}

export function parseUrl(url: string): any {
  const a = document.createElement("a");
  a.href = url;
  return {
    source: url,
    protocol: a.protocol.replace(":", ""),
    host: a.hostname || window.location.host,
    port: a.port,
    query: a.search,
    params: (function() {
      const ret = {},
        seg = a.search.replace(/^\?/, "").split("&"),
        len = seg.length;
      let i = 0,
        s;
      for (; i < len; i++) {
        if (!seg[i]) {
          continue;
        }
        s = seg[i].split("=");
        ret[s[0]] = s[1];
      }
      return ret;
    })(),
    file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ""])[1],
    hash: a.hash.replace("#", ""),
    path: a.pathname.replace(/^([^\/])/, "/$1"),
    relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ""])[1],
    segments: a.pathname.replace(/^\//, "").split("/")
  };
}

export function showNode(node) {
  const domNode =
    typeof node === "string" ? document.querySelector(node) : node;
  if (domNode) {
    domNode.classList.remove("hide");
  }
}

export function hideNode(node) {
  const domNode =
    typeof node === "string" ? document.querySelector(node) : node;
  if (domNode) {
    domNode.classList.add("hide");
  }
}

export function toggleNode(node) {
  const showHide =
    node && node.classList.contains("hide") ? "showNode" : "hideNode";
  this[showHide](node);
}

export function isNodeVisible(node) {
  return node && node.classList.contains("hide") ? false : true;
}

export function find(arr: any[], fn: Function) {
  let value;
  for (let i = 0; i < arr.length; i++) {
    value = arr[i];
    if (fn(value)) {
      return value;
    }
  }
  return null;
}

export function isRTL() {
  return document.getElementsByTagName("html")[0].getAttribute("dir") === "rtl";
}

export function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

let _isDarkMode: boolean;
export function isDarkMode() : "dark" | "light"{
  if(_isDarkMode != null){
    return _isDarkMode ? "dark" : "light";
  }
  _isDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
  return _isDarkMode ? "dark" : "light";
}



const ROOT_BADGE_TYPE_KEYWORD = "InstantAppGallery:Badge:";
/** Parse TypeKeyword for portalitem to get the proper badge to show */
export function findAppTypeBadge(item: __esri.PortalItem): string | null {
  let badgeStr = item.typeKeywords.find((keyword: string) => {
    return keyword.indexOf(ROOT_BADGE_TYPE_KEYWORD) != -1;
  });
  if (badgeStr != null) { badgeStr = badgeStr.replace(ROOT_BADGE_TYPE_KEYWORD, "").trim(); }
  return badgeStr;
}

export function keyboardAccessibleHelper(callback: Function, e: KeyboardEvent){
  if(e.code === "Enter" || e.code === "Space"){
    e.preventDefault();
    callback();
  }
}

export function isNoResourceInQueryString(): boolean{
  const urlParams = new URLSearchParams(window.location.search);
  return !(urlParams.has('webmap') || urlParams.has('webscene') || urlParams.has('group'));
}
